module.exports = __webpack_public_path__ + "img/logo-bri.ef299542.png";